import { Link, routes } from '@redwoodjs/router'
import { Toaster } from '@redwoodjs/web/toast'

type GymLayoutProps = {
  children: React.ReactNode
}

const GymsLayout = ({ children }: GymLayoutProps) => {
  return (
    <div className="rw-scaffold">
      <Toaster />
      <header className="rw-header">
        <h1 className="rw-heading rw-heading-primary">
          <Link to={routes.gymsAdmin()} className="rw-link">
            Gyms
          </Link>
        </h1>
        <Link to={routes.newGymAdmin()} className="rw-button rw-button-green">
          <div className="rw-button-icon">+</div> New Gym
        </Link>
      </header>
      <main className="rw-main">{children}</main>
    </div>
  )
}

export default GymsLayout
